import { Component, Input } from '@angular/core';
import { AiMessage } from '../../models';

@Component({
  selector: 'app-ai-text-renderer',
  templateUrl: './text-renderer.component.html',
  styleUrls: ['./text-renderer.component.scss']
})
export class TextRendererComponent {
  @Input() message!: AiMessage;
}

